import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  compose, withState, withHandlers, lifecycle,
} from 'recompose'
import { message } from 'antd'
import { updateSiteConfigs } from 'actions/Site'
import { generateSupportSessionCode, verifyPassword } from 'actions/SupportSession'
import SupportSession from 'components/pages/supportSession'

export function mapStateToProps(state) {
  const { currentUser } = state.root.auth
  return {
    currentUser,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  generateSupportSessionCode: bindActionCreators(generateSupportSessionCode, dispatch),
  verifyPassword: bindActionCreators(verifyPassword, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isGenerating', 'setIsGenerating', false),
  withState('session', 'setSession', null),
  withState('isConfirmModalOpen', 'setIsConfirmModalOpen', false),
  withState('password', 'setPassword', ''),
  withState('isVerifying', 'setIsVerifying', false),
  withState('isRevealed', 'setIsRevealed', false),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfigs({
        titlePage: 'Support Session',
        activePage: 'support-session',
        activeSubPage: 'support-session',
      })
    },
  }),
  withHandlers({
    handleGenerate: props => (values) => {
      const { setIsGenerating, setSession, setIsRevealed } = props
      setIsGenerating(true)
      props.generateSupportSessionCode(values)
        .then((data) => {
          setIsGenerating(false)
          setSession(data)
          setIsRevealed(false)
        })
        .catch((err) => {
          setIsGenerating(false)
          message.error(err)
        })
    },
    handleReset: props => () => {
      props.setSession(null)
      props.setIsRevealed(false)
      props.setPassword('')
    },
    openConfirmModal: props => () => {
      props.setIsConfirmModalOpen(true)
    },
    closeConfirmModal: props => () => {
      props.setIsConfirmModalOpen(false)
      props.setPassword('')
    },
    handleChangePassword: props => (e) => {
      props.setPassword(e.target.value)
    },
    handleConfirmReveal: props => () => {
      const { password, setIsVerifying } = props
      if (!password) {
        message.error('Password wajib diisi')
        return
      }
      setIsVerifying(true)
      props.verifyPassword({ password }).then(() => {
        setIsVerifying(false)
        props.setIsConfirmModalOpen(false)
        props.setIsRevealed(true)
        props.setPassword('')
      }).catch((err) => {
        setIsVerifying(false)
        props.setPassword('')
        message.error(err)
      })
    },
    handleHide: props => () => {
      props.setIsRevealed(false)
    },
  }),
)(SupportSession)
